import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import MostOfferedPerks from './charts/MostOfferedPerks';
import MethodologyAnchor from './MethodologyAnchor';
import { StyledChart, StyledSection } from './OfferedPerks.styled';

const OfferedPerks: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  return (
    <StyledSection>
      <div>
        <Heading3>{t('salaries.perks.title')}</Heading3>
        <div
          dangerouslySetInnerHTML={{
            __html: t('salaries.perks.desc')
          }}
        ></div>
        <MethodologyAnchor />
      </div>
      <StyledChart>
        <MostOfferedPerks />
      </StyledChart>
    </StyledSection>
  );
};

export default OfferedPerks;
